import {defineMessages} from 'react-intl';

export default defineMessages({
	size: {
		id: 'orders.orderDetailsItem.size',
		defaultMessage: 'Size: {size}',
	},
	quantity: {
		id: 'orders.orderDetailsItem.quantity',
		defaultMessage: 'Qty: {qty}',
	},
	productId: {
		id: 'orders.orderDetailsItem.productId',
		defaultMessage: 'COD: {productId}',
	},
});
